interface Props {
  code: string;
  hoverLabel: string;
  isSuffix?: boolean;
}

export function PartChip({ code, hoverLabel, isSuffix = false }: Props) {
  return (
    <span className="group relative inline-flex" data-part-chip>
      <span
        className={`rounded-[3px] border px-1.5 py-px font-mono text-[11.5px] whitespace-nowrap cursor-help ${
          isSuffix ? "border-dashed border-rs-jet-light text-rs-light-gray" : "border-rs-jet text-rs-off-white"
        }`}
        tabIndex={0}
        aria-label={`${code}: ${hoverLabel}`}
      >
        {code}
      </span>
      <span
        className="pointer-events-none absolute bottom-full left-1/2 z-20 mb-1 w-max max-w-64 -translate-x-1/2 rounded border border-rs-jet-light bg-rs-black px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 group-focus-within:opacity-100"
        aria-hidden="true"
      >
        {hoverLabel}
      </span>
    </span>
  );
}
